export default function ({ store, route }) {
  const activatePosMenu = route.path.startsWith('/pos')
  // avoids polluting dev tools store commit logs
  // by checking if the value is the same in the store and don't commit if true
  if (store.state.ui.posMenuVisible !== !!activatePosMenu)
    store.commit('ui/setPosMenuVisible', !!activatePosMenu)
}
